import type { FC } from 'react';
import { clientOnly } from 'vike-react/clientOnly';
import styles from './Tower.module.css';
import towerImg from './tower.png';

const TowerPureWrapped = clientOnly(() => import ('./TowerPureWrapped').then(r => r.TowerPureWrapped));

export const Tower: FC = () => (
    <div className={styles.container}>
        <TowerPureWrapped
            fallback={<img width="100%" src={towerImg} alt="ULLL Tower" />}
        />
    </div>
);
